import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgElephant = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.75 7.4261V14.1847L6.13462 10.8054M0.75 7.4261L0.75 0.66748L4.51923 2.59852M0.75 7.4261L4.51923 7.4261M14.75 7.4261V14.1847L9.36538 10.8054M14.75 7.4261L14.75 0.66748L10.9808 2.59852M14.75 7.4261H10.9808M10.9808 7.4261V2.59852M10.9808 7.4261L9.36538 10.8054M4.51923 2.59852L7.75 0.667481L10.9808 2.59852M4.51923 2.59852L4.51923 7.4261M4.51923 7.4261L6.13462 10.8054M9.36538 10.8054V14.6675H6.25L6.13462 10.8054",
		stroke: "black",
		strokeWidth: 1.5,
		strokeLinejoin: "bevel"
	})
});
export default SvgElephant;
